import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { AbsenceType } from '@cl/shared/models/absences/absence-type.model';
import { BaseFilterModel } from '@cl/shared/models/base/base-filter-model.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class AbsenceTypesService extends BaseServiceWithFilter<AbsenceType, BaseFilterModel> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/absence-types/');
    }
}
